export default "__VITE_ASSET__DQehOwd2__"